import * as Yup from "yup";
export const billingAddressValidation = Yup.object().shape({
  address_name: Yup.string(),
  sub_district: Yup.string().nullable(),
  district: Yup.string().nullable(),
  province: Yup.string().nullable(),
  postal_code: Yup.string().nullable(),
  country: Yup.string(),
});
